import { Laptop, Layers, LayoutGrid, RefreshCw, Trophy } from "lucide-react";
import Reveal from "@/components/Reveal";
import { sz, txt, useContent } from "@/content/ContentContext";

const statIcons = [
  <Layers className="stat-icon" strokeWidth={1.3} key="layers" />,
  <LayoutGrid className="stat-icon" strokeWidth={1.3} key="grid" />,
  <Laptop className="stat-icon" strokeWidth={1.3} key="laptop" />,
  <RefreshCw className="stat-icon" strokeWidth={1.3} key="refresh" />,
  <Trophy className="stat-icon" strokeWidth={1.3} key="trophy" />,
];

const StatsBar = () => {
  const c = useContent();
  const items = c.home.stats.items;

  return (
    <section className="statsbar" aria-label="Company statistics">
      {items.map((stat, index) => (
        <div className="stat-group" key={index}>
          {index > 0 && <span className="stat-divider" />}
          <Reveal className="stat-item" delay={index * 0.09} y={18}>
            <div className="stat-main">
              {statIcons[index]}
              <div className="stat-text">
                <span className="stat-value" style={sz(stat.value)}>{txt(stat.value)}</span>
                <span className="stat-label" style={sz(stat.label)}>{txt(stat.label)}</span>
              </div>
            </div>
            <span className="stat-sub" style={sz(stat.sub)}>{txt(stat.sub)}</span>
          </Reveal>
        </div>
      ))}
    </section>
  );
};

export default StatsBar;
